export default [
  {
    path: '/admin/leave-sub-items',
    name: 'leave-sub-item',
    meta: { requiresAuth: true },
    component: () => import('@/pages/human-resource/leave-sub-item/index-v2.vue')
  }
]
